module.exports = __webpack_public_path__ + "media/images/self-computer-play-5a2455411e3038d00b4befd2f0c13ef9.png";